import '../sass/frontend.scss';

import checkoutGiftCard from './frontend/checkout-gift-card';

jQuery(function () {
    checkoutGiftCard.init();
});
